import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const UmbrellaSubscriptionsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 291px;
  grid-column-gap: ${Spacing.S32};
`

export const LeftSideWrapper = styled.div`
  display: flex;
  flex-direction: column;
`
